import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Program History|Continuing Education|Progress|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CredentialContinuingEducationCeProgress,
	portal: 'SP',
};
const columnHeadingDescriptionStart = 'Column heading for: ';

type LocNameStart = 'SPCandidateCeProgress';
export type SPCandidateCeProgressLocNames =
	| `${LocNameStart}TitleProgressSection`
	| `${LocNameStart}LabelStatus`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelNameAbbr`
	| `${LocNameStart}LabelProgressStartDate`
	| `${LocNameStart}LabelProgressEndDate`
	| `${LocNameStart}LabelProgress`
	| `${LocNameStart}LabelCycleStartDate`
	| `${LocNameStart}LabelCycleDaysRemaining`;

export const spCandidateCeProgressLocs: LocDefs<SPCandidateCeProgressLocNames> = {
	SPCandidateCeProgressTitleProgressSection: {
		defaultValue: 'Continuing Education Progress',
		description: `${columnHeadingDescriptionStart}Continuing Education Progress Title.`,
		displayPath: `${pathStart}Continuing Education Progress Title`,
		displayType: 'Title',
		legacyName:
			'Credential.ContinuingEducation/Candidates.ProgramHistory.ContinuingEducation.Progress.Title.SectionTitle',
		...sharedProperties,
	},
	SPCandidateCeProgressLabelStatus: {
		defaultValue: 'Status',
		description: `${columnHeadingDescriptionStart}Status.`,
		displayPath: `${pathStart}Status`,
		displayType: 'Label',
		legacyName: 'Credential.ContinuingEducation/Credentials.Progress.FieldLabel.Status',
		...sharedProperties,
	},
	SPCandidateCeProgressLabelName: {
		defaultValue: 'Credential',
		description: `${columnHeadingDescriptionStart}Credential.`,
		displayPath: `${pathStart}Credential`,
		displayType: 'Label',
		legacyName: 'Credential.ContinuingEducation/Credentials.Progress.FieldLabel.Credential',
		...sharedProperties,
	},
	SPCandidateCeProgressLabelNameAbbr: {
		defaultValue: 'Code',
		description: `${columnHeadingDescriptionStart}Code.`,
		displayPath: `${pathStart}Code`,
		displayType: 'Label',
		legacyName: 'Credential.ContinuingEducation/Credentials.Progress.FieldLabel.Code',
		...sharedProperties,
	},
	SPCandidateCeProgressLabelProgressStartDate: {
		defaultValue: 'Progress Start Date',
		description: `${columnHeadingDescriptionStart}Progress Start Date.`,
		displayPath: `${pathStart}Progress Start Date`,
		displayType: 'Label',
		legacyName:
			'Credential.ContinuingEducation/Credentials.Progress.FieldLabel.ProgressStartDate',
		...sharedProperties,
	},
	SPCandidateCeProgressLabelProgressEndDate: {
		defaultValue: 'Progress End Date',
		description: `${columnHeadingDescriptionStart}Progress End Date.`,
		displayPath: `${pathStart}Progress End Date`,
		displayType: 'Label',
		legacyName:
			'Credential.ContinuingEducation/Credentials.Progress.FieldLabel.ProgressEndDate',
		...sharedProperties,
	},
	SPCandidateCeProgressLabelProgress: {
		defaultValue: 'Progress',
		description: `${columnHeadingDescriptionStart}Progress.`,
		displayPath: `${pathStart}Progress`,
		displayType: 'Label',
		legacyName:
			'Credential.ContinuingEducation/Credentials.Progress.FieldLabel.CompletionPercentage',
		...sharedProperties,
	},
	SPCandidateCeProgressLabelCycleStartDate: {
		defaultValue: 'Cycle Start Date',
		description: `${columnHeadingDescriptionStart}Cycle Start Date.`,
		displayPath: `${pathStart}Cycle Start Date`,
		displayType: 'Label',
		shared: false,
		htmlAllowed: false,
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		portal: 'SP',
	},
	SPCandidateCeProgressLabelCycleDaysRemaining: {
		defaultValue: 'Cycle Days Remaining',
		description: `${columnHeadingDescriptionStart}Cycle Days Remaining.`,
		displayPath: `${pathStart}Cycle Days Remaining`,
		displayType: 'Label',
		shared: false,
		htmlAllowed: false,
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		portal: 'SP',
	},
};

export type SPCandidateCeProgressLocType = LocMap<SPCandidateCeProgressLocNames>;
